import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";
import ContentWrapper from "../../../../common/components/ContentWrapper";
import { TableContainer } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { changeSidebarButtonState } from "../../../dashboard/actions/dashboardSidebarActions";
import AlertDialogSlide from "../../../../common/components/AlertDialog";
import {
  fetchOrganizations,
  addOrganization,
  editOrganization,
  deleteOrganization,
} from "../actions/organizationActions";

// ------------------ OrganizationForm ------------------
class OrganizationForm extends Component {
  state = {
    name: this.props.existingOrganization?.name || "",
    nameError: "",
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      nameError: "",
    });
  };

  handleSubmit = () => {
    const { name } = this.state;
    if (!name) {
      this.setState({ nameError: "Organization name is required." });
      return;
    }

    const formData = new FormData();
    formData.append("name", name);

    const action = this.props.showEditOrganization
      ? this.props.editOrganization
      : this.props.addOrganization;

    if (this.props.showEditOrganization) {
      action(
        this.props.existingOrganization.id,
        formData,
        (response) => {
          toast("Organization updated successfully.", {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
          });
          this.props.fetchOrganizations();
          this.props.handleCloseOrganizationForm();
        },
        (error) => {
          this.setState({
            nameError:
              error.response?.data?.name ||
              error.response?.data?.message ||
              "An error occurred.",
          });
        }
      );
    } else {
      action(
        formData,
        (response) => {
          toast("Organization added successfully.", {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
          });
          this.props.fetchOrganizations();
          this.props.handleCloseOrganizationForm();
        },
        (error) => {
          this.setState({
            nameError:
              error.response?.data?.name ||
              error.response?.data?.message ||
              "An error occurred.",
          });
        }
      );
    }
  };

  render() {
    const {
      openOrganizationForm,
      handleCloseOrganizationForm,
      showEditOrganization,
    } = this.props;
    const { name, nameError } = this.state;

    return (
      <Dialog open={openOrganizationForm} onClose={handleCloseOrganizationForm}>
        <DialogTitle>
          {showEditOrganization ? "Edit Organization" : "Add Organization"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="name"
            label="Organization Name"
            type="text"
            fullWidth
            value={name}
            onChange={this.handleChange}
            error={!!nameError}
            helperText={nameError}
          />
        </DialogContent>
        <div className="form-button-container" style={{ padding: "8px" }}>
          <a
            onClick={handleCloseOrganizationForm}
            variant="outlined"
            className="btn form-cancel-button"
            style={{ flex: 1 }}
          >
            Cancel
          </a>
          <a
            onClick={this.handleSubmit}
            variant="outlined"
            className="btn form-submit-button btn-default"
            style={{ flex: 1 }}
          >
            {showEditOrganization ? "Update" : "Add"}
          </a>
        </div>
      </Dialog>
    );
  }
}

// ------------------ OrganizationComponent ------------------
class OrganizationComponent extends Component {
  state = {
    openOrganizationForm: false,
    showEditOrganization: false,
    organizationID: null,
    existingOrganization: {},
    openAlertDelete: false,
    deleteOrgID: null,
  };

  componentDidMount() {
    this.props.changeSidebarButtonState(
      "organizations",
      "ORGANIZATIONS_BTN_ACTIVE"
    );
    this.props.fetchOrganizations();
  }

  showEditOrganizationDialog = (existingOrganization) => {
    this.setState({
      showEditOrganization: true,
      openOrganizationForm: true,
      existingOrganization,
    });
  };

  handleClickOpenOrganizationForm = () => {
    this.setState({ openOrganizationForm: true });
  };

  handleCloseOrganizationForm = () => {
    this.setState({
      openOrganizationForm: false,
      showEditOrganization: false,
      existingOrganization: {},
    });
  };

  // ------------------ Delete handlers ------------------
  handleDeleteOrganization = (id) => {
    this.setState({ openAlertDelete: true, deleteOrgID: id });
  };

  closeDeleteOrganizationAlert = () => {
    this.setState({ openAlertDelete: false, deleteOrgID: null });
  };

  confirmDeleteOrganization = () => {
    const { deleteOrgID } = this.state;
    if (!deleteOrgID) return;

    this.props.deleteOrganization(
      deleteOrgID,
      () => {
        toast("Organization deleted successfully.", {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.TOP_CENTER,
        });
        this.props.fetchOrganizations();
        this.closeDeleteOrganizationAlert();
      },
      (error) => {
        toast(
          error.response?.data?.message || "Failed to delete organization.",
          {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
          }
        );
        this.closeDeleteOrganizationAlert();
      }
    );
  };

  getContentView = () => {
    const { organizations } = this.props;
    const role = localStorage.getItem("roleKey");

    return (
      <div className="content-wrapper">
        <div className="content">
          <div
            className="main_top_headding"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4>
              <i className="fa fa-building" aria-hidden="true"></i>{" "}
              Organizations
            </h4>
            {role === "owner" && (
              <button
                type="button"
                className="btn btn-outline-secondary pull-right"
                onClick={this.handleClickOpenOrganizationForm}
              >
                <span className="glyphicon glyphicon-plus"></span>{" "}
                <strong>Add Organization</strong>
              </button>
            )}
          </div>

          <div className="row common_div_row">
            <Paper>
              <TableContainer className="table-all table-responsive">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className="text-wrap-head">
                        ID
                      </TableCell>
                      <TableCell align="left" className="text-wrap-head">
                        Name
                      </TableCell>
                      {role === "owner" && (
                        <>
                          <TableCell align="left" className="text-wrap-head">
                            Edit
                          </TableCell>
                          <TableCell align="left" className="text-wrap-head">
                            Delete
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {organizations.length > 0 &&
                      organizations.map((org) => (
                        <TableRow key={org.id}>
                          <TableCell align="left" className="text-wrap">
                            {org.id}
                          </TableCell>
                          <TableCell align="left" className="text-wrap">
                            {org.name}
                          </TableCell>
                          {role === "owner" && (
                            <>
                              <TableCell align="left" className="text-wrap">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  onClick={() =>
                                    this.showEditOrganizationDialog(org)
                                  }
                                >
                                  <span className="glyphicon glyphicon-edit"></span>
                                </button>
                              </TableCell>
                              <TableCell align="left" className="text-wrap">
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() =>
                                    this.handleDeleteOrganization(org.id)
                                  }
                                >
                                  <span className="glyphicon glyphicon-trash"></span>
                                </button>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>

          {this.state.openOrganizationForm && (
            <OrganizationForm
              openOrganizationForm={this.state.openOrganizationForm}
              showEditOrganization={this.state.showEditOrganization}
              existingOrganization={this.state.existingOrganization}
              handleCloseOrganizationForm={this.handleCloseOrganizationForm}
              addOrganization={this.props.addOrganization}
              editOrganization={this.props.editOrganization}
              fetchOrganizations={this.props.fetchOrganizations}
            />
          )}

          {/* Custom delete alert */}
          <AlertDialogSlide
            open={this.state.openAlertDelete}
            handleClose={this.closeDeleteOrganizationAlert}
            title={"Delete Organization?"}
            desc={"Are you sure you want to delete this organization?"}
            action={this.confirmDeleteOrganization}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <ContentWrapper
        contentView={this.getContentView()}
        netError={this.props.netError}
      />
    );
  }
}

// ------------------ Redux ------------------
function mapStateToProps(state) {
  return {
    organizations: state.organizationsInfo?.organizationsInfo || [],
    netError: state.organizationsInfo?.netError,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeSidebarButtonState,
      fetchOrganizations,
      addOrganization,
      editOrganization,
      deleteOrganization,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationComponent);
